import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/404/Page404"
    },
    {
      path: "/",
      redirect: "/Index",
      component: Index,
      meta: { title: "主页" }
    },
    {
      path: "/Index",
      name: "index",
      component: Index,
      meta: { title: "主页" }
    },
    {
      path: "/data",
      name: "data",
      component: () => import("../components/Index-echartsMap"),
      meta: { title: "主页2" }
    },
    {
      path: '/usefInfo',
      name: 'usefInfo',
      component: () => import("../components/user/userInfo"),
      meta: {title: "用户信息"}
    },
 {
      path: '/User',
      name: 'User',
      component: () => import("../components/user/User"),
      meta: {title: "用户列表"}
    },
    {
      path: '/UserAdd',
      name: 'UserAdd',
      component: () => import("../components/user/UserAdd"),
      meta: {title: "用户新增"}
    },

    {
      path: '/UserEdit',
      name: 'UserEdit',
      component: () => import("../components/user/UserEdit"),
      meta: {title: "用户列表"}
    },
    //permission
    {
      path: '/Permission',
      name: 'Permission',
      component: () => import("../components/permission/Permission"),
      meta: {title: "权限"}
    },   {
      path: '/PermissionAdd',
      name: 'PermissionAdd',
      component: () => import("../components/permission/PermissionAdd"),
      meta: {title: "权限新增"}
    },   {
      path: '/PermissionEdit',
      name: 'PermissionEdit',
      component: () => import("../components/permission/PermissionEdit"),
      meta: {title: "权限编辑"}
    },   {
      path: '/PermissionGroup',
      name: 'PermissionGroup',
      component: () => import("../components/permission/PermissionGroup"),
      meta: {title: "权限组"}
    },   {
      path: '/PermissionGroupAdd',
      name: 'PermissionGroupAdd',
      component: () => import("../components/permission/PermissionGroupAdd"),
      meta: {title: "权限组新增"}
    },   {
      path: '/PermissionGroupEdit',
      name: 'PermissionGroupEdit',
      component: () => import("../components/permission/PermissionGroupEdit"),
      meta: {title: "权限组编辑"}
    },

















    {
      path: "/monmap",
      name: "monmap",
      component: () => import("../components/404/monmap"),
      meta: { title: "监控对象地图" }
    },
    {
      path: "/devmap",
      name: "devmap",
      component: () => import("../components/404/devmap"),
      meta: { title: "设备地图" }
    },
    {
      path: "/map",
      name: "map",
      component: () => import("../components/404/map"),
      meta: { title: "地图" }
    },
    // 404
    {
      path: "/404/Page404",
      name: "Page404",
      component: () => import("../components/404/Page404"),
      meta: { title: "页面丢失" }
    },
    // 公司管理
    {
      path: "/companybundle/index",
      name: "index",
      component: () => import("../components/companybundle/index"),
      meta: { title: "公司基本信息" }
    },
    {
      path: "/companybundle/noplatuser",
      name: "noplatuser",
      component: () => import("../components/companybundle/noplatuser"),
      meta: { title: "部门人员管理" }
    },
    {
      path: "/companybundle/platuser",
      name: "platuser",
      component: () => import("../components/companybundle/platuser"),
      meta: { title: "联系人" }
    },
    {
      path: "/company/Company",
      name: "Company",
      component: () => import("../components/company/Company"),
      meta: { title: "公司管理" }
    },

    //Company
    {
      path: '/companyAdmin/Company',
      name: 'Company',
      component: () => import('../components/companyAdmin/Company.vue'),
      meta: {
        title: '公司列表',
        name: '公司列表',
      }
    },
    {
      path: '/companyAdmin/CompanyAdd',
      name: 'CompanyAdd',
      component: () => import('../components/companyAdmin/CompanyAdd.vue'),
      meta: {
        title: '公司添加',
        name: '公司添加',
        array: [{name: '公司列表', path: '/Company'}, {name: '公司列表', path: '/CompanyAdd'}]
      }
    },
    {
      path: '/companyAdmin/CompanyEdit',
      name: 'CompanyEdit',
      component: () => import('../components/companyAdmin/CompanyEdit.vue'),
      meta: {
        title: '公司编辑',
        name: '公司编辑',
        array: [{name: '公司列表', path: '/Company'}, {name: '公司编辑', path: '/CompanyEdit'}]
      }
    },
    {
      path: '/companyAdmin/DeptList',
      name: 'DeptList',
      component: () => import('../components/companyAdmin/DeptList.vue'),
      meta: {
        title: '部门列表',
        name: '部门列表',
      }
    },



    {
      path: "/company/CreateCompany",
      name: "CreateCompany",
      component: () => import("../components/company/CreateCompany"),
      meta: { title: "创建公司" }
    },
    {
      path: "/company/TransferCompany",
      name: "TransferCompany",
      component: () => import("../components/company/TransferCompany"),
      meta: { title: "转让公司" }
    },



    {
      path: "/company/NoPlatformUser",
      name: "NoPlatformUser",
      component: () => import("../components/company/NoPlatformUser"),
      meta: { title: "联系人管理" }
    },
    {
      path: "/company/Departmentuser",
      name: "Departmentuser",
      component: () => import("../components/company/Departmentuser"),
      meta: { title: "部门人员管理" }
    },
    // 日志中心
    {
      path: "/log/Userlog",
      name: "Userlog",
      component: () => import("../components/log/Userlog"),
      meta: { title: "用户日志" }
    },
    {
      path: "/log/MonitorobjectLog",
      name: "MonitorobjectLog",
      component: () => import("../components/log/MonitorobjectLog"),
      meta: { title: "监控对象日志" }
    },
    {
      path: "/log/Devlog",
      name: "Devlog",
      component: () => import("../components/log/Devlog"),
      meta: { title: "设备日志" }
    },
    // 报警管理
    {
      path: "/alarm/Rule",
      name: "Rule",
      component: () => import("../components/alarm/Rule"),
      meta: { title: "报警规则" }
    },
    {
      path: "/alarm/RuleAdd",
      name: "RuleAdd",
      component: () => import("../components/alarm/RuleAdd"),
      meta: { title: "报警规则添加" }
    },
    {
      path: "/alarm/RuleDetial",
      name: "RuleDetial",
      component: () => import("../components/alarm/RuleDetial"),
      meta: { title: "报警规则详情" }
    },
    {
      path: "/alarm/RuleBind",
      name: "RuleBind",
      component: () => import("../components/alarm/RuleBind"),
      meta: { title: "报警规则绑定" }
    },
    {
      path: "/alarm/RuleEdit",
      name: "RuleEdit",
      component: () => import("../components/alarm/RuleEdit"),
      meta: { title: "报警规则编辑" }
    },
    {
      path: "/alarm/Rulelog",
      name: "Rulelog",
      component: () => import("../components/alarm/Rulelog"),
      meta: { title: "报警记录" }
    },

    //设备
    {
      path: "/dev/DevView",
      name: "DevView",
      component: () => import("../components/dev/DevView"),
      meta: { title: "设备视图" }
    },

    {
      path: "/dev/DevList",
      name: "DevList",
      component: () => import("../components/dev/DevList"),
      meta: { title: "设备列表" }
    },
    {
      path: "/dev/DevAdd",
      name: "DevAdd",
      component: () => import("../components/dev/DevAdd"),
      meta: { title: "设备新增" }
    },
    {
      path: "/dev/DevEdit",
      name: "DevEdit",
      component: () => import("../components/dev/DevEdit"),
      meta: { title: "设备编辑" }
    },
    {
      path: "/dev/DevHistoryData",
      name: "DevHistoryData",
      component: () => import("../components/dev/DevHistoryData"),
      meta: { title: "设备历史数据" }
    },
    {
      path: "/dev/DevHistoryDataTwo",
      name: "DevHistoryDataTwo",
      component: () => import("../components/dev/DevHistoryDataTwo"),
      meta: { title: "设备历史数据(二版)" }
    },
    {
      path: "/dev/DevHistoryDataOver",
      name: "DevHistoryDataOver",
      component: () => import("../components/dev/DevHistoryDataOver"),
      meta: { title: "设备超标数据" }
    },
    {
      path: "/dev/DevHistoryDataOverTwo",
      name: "DevHistoryDataOverTwo",
      component: () => import("../components/dev/DevHistoryDataOverTwo"),
      meta: { title: "设备超标数据(二版)" }
    },
    {
      path: "/dev/DataHandle",
      name: "DataHandle",
      component: () => import("../components/dev/DataHandle"),
      meta: { title: "超标事务处理" }
    },
    {
      path: "/dev/DataHandleDetial",
      name: "DataHandleDetial",
      component: () => import("../components/dev/DataHandleDetial"),
      meta: { title: "超标处理详情" }
    },
    {
      path: "/dev/DataOverHandle",
      name: "DataOverHandle",
      component: () => import("../components/dev/DataOverHandle"),
      meta: { title: "超标处理" }
    },
    {
      path: "/dev/DevCurve",
      name: "DevCurve",
      component: () => import("../components/dev/DevCurve"),
      meta: { title: "历史曲线" }
    },
    {
      path: "/dev/DevPdf",
      name: "DevPdf",
      component: () => import("../components/dev/DevPdf"),
      meta: { title: "历史曲线打印" }
    },
    {
      path: "/dev/DevCurveTwo",
      name: "DevCurveTwo",
      component: () => import("../components/dev/DevCurveTwo"),
      meta: { title: "历史曲线(二版)" }
    },
    {
      path: "/dev/DevLocation",
      name: "DevLocation",
      component: () => import("../components/dev/DevLocation"),
      meta: { title: "定位" }
    },
    {
      path: "/dev/DevLocationPlayBack",
      name: "DevLocationPlayBack",
      component: () => import("../components/dev/DevLocationPlayBack"),
      meta: { title: "定位回放" }
    },
    //监控对象
    {
      path: "/monitor/MonitorView",
      name: "MonitorView",
      component: () => import("../components/monitor/MonitorView"),
      meta: { title: "监控对象视图" }
    },
    {
      path: "/monitor/MonitorList",
      name: "MonitorList",
      component: () => import("../components/monitor/MonitorList"),
      meta: { title: "监控对象列表" }
    },
    {
      path: "/monitor/MaintenanceRecord",
      name: "MaintenanceRecord",
      component: () => import("../components/monitor/MaintenanceRecord"),
      meta: { title: "维修记录" }
    },
    {
      path: "/monitor/MaintenanceRecordAdd",
      name: "MaintenanceRecordAdd",
      component: () => import("../components/monitor/MaintenanceRecordAdd"),
      meta: { title: "维修记录新增" }
    },
    {
      path: "/monitor/MonitorUser",
      name: "MonitorUser",
      component: () => import("../components/monitor/MonitorUser"),
      meta: { title: "分配对象" }
    },
    {
      path: "/monitor/MonitorRebind",
      name: "MonitorRebind",
      component: () => import("../components/monitor/MonitorRebind"),
      meta: { title: "重新关联" }
    },
    {
      path: "/monitor/MonitorDistribute",
      name: "MonitorDistribute",
      component: () => import("../components/monitor/MonitorDistribute"),
      meta: { title: "分配对象 - 分配" }
    },
    {
      path: "/monitor/MonitorHistoryData",
      name: "MonitorHistoryData",
      component: () => import("../components/monitor/MonitorHistoryData"),
      meta: { title: "监控对象历史数据" }
    },
    {
      path: "/monitor/MonitorHistoryDataOver",
      name: "MonitorHistoryDataOver",
      component: () => import("../components/monitor/MonitorHistoryDataOver"),
      meta: { title: "监控对象超标数据" }
    },
    {
      path: "/monitor/MonitorCurve",
      name: "MonitorCurve",
      component: () => import("../components/monitor/MonitorCurve"),
      meta: { title: "监控对象历史曲线" }
    },
    {
      path: "/monitor/MonitorAdd",
      name: "MonitorAdd",
      component: () => import("../components/monitor/MonitorAdd"),
      meta: { title: "监控对象新增" }
    },
    {
      path: "/monitor/MonitorEdit",
      name: "MonitorEdit",
      component: () => import("../components/monitor/MonitorEdit"),
      meta: { title: "监控对象编辑" }
    },
    {
      path: "/monitor/DragMap",
      name: "DragMap",
      component: () => import("../components/monitor/DragMap"),
      meta: { title: "布点图" }
    },
    {
      path: "/monitor/DragDetial",
      name: "DragDetial",
      component: () => import("../components/monitor/DragDetial"),
      meta: { title: "布点图详情" }
    },
    //消息 公告
    {
      path: "/msg/Notice",
      name: "Notice",
      component: () => import("../components/msg/Notice"),
      meta: { title: "公告" }
    },
    {
      path: "/msg/Msg",
      name: "Msg",
      component: () => import("../components/msg/Msg"),
      meta: { title: "消息" }
    },
    //物流
    {
      path: "/logistical/LogisticalList",
      name: "LogisticalList",
      component: () => import("../components/logistical/LogisticalList"),
      meta: { title: "运单列表" }
    },
    {
      path: "/logistical/LogisticalAdd",
      name: "LogisticalAdd",
      component: () => import("../components/logistical/LogisticalAdd"),
      meta: { title: "运单新增" }
    },
    {
      path: "/logistical/LogisticalEdit",
      name: "LogisticalEdit",
      component: () => import("../components/logistical/LogisticalEdit"),
      meta: { title: "运单编辑" }
    },
    {
      path: "/logistical/LogisticalFind",
      name: "LogisticalFind",
      component: () => import("../components/logistical/LogisticalFind"),
      meta: { title: "运单查询" }
    },
    {
      path: "/logistical/LogisticalFindInfo",
      name: "LogisticalFindInfo",
      component: () => import("../components/logistical/LogisticalFindInfo"),
      meta: { title: "运单详情" }
    },

    {
      path: "/print/DevPdf",
      name: "DevPdf",
      component: () => import("../components/print/DevPdf"),
      meta: { title: "设备数据打印" }
    },
    {
      path: "/DevViewAll",
      name: "DevViewAll",
      component: () => import("../components/dev/DevViewAll"),
      meta: { title: "设备视图" }
    },
    {
      path: "/DevViewAll18",
      name: "DevViewAll18",
      component: () => import("../components/dev/DevViewAll18"),
      meta: { title: "设备视图" }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../components/login/login"),
      meta: { title: "login" }
    },
    {
      path: "/type",
      name: "type",
      component: () => import("../components/dev/type"),
      meta: { title: "分类" }
    },
    {
      path: '/api/Example',
      name: 'Example',
      component: () => import("../components/api/Example"),
      meta: {
        title: "加密与请求实例",
        name: "加密与请求实例",
      }
    },
    {
      path: '/api/GetDevData',
      name: 'GetDevData',
      component: () => import("../components/api/GetDevData"),
      meta: {
        title: "获取设备历史数据接口",
        name: "获取设备历史数据接口",
      }
    },
    {
      path: '/api/ListDevStatusBySN',
      name: 'ListDevStatusBySN',
      component: () => import("../components/api/ListDevStatusBySN"),
      meta: {
        title: "获取设备实时状态接口",
        name: "获取设备实时状态接口",
      }
    },
    {
      path: '/api/GetDevList',
      name: 'GetDevList',
      component: () => import("../components/api/GetDevList"),
      meta: {
        title: "获取设备列表接口",
        name: "获取设备列表接口",
      }
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js